// removed by extract-text-webpack-plugin
module.exports = {"wrap":"index_2aS8emp","wrap_top":"index_2O1A3CT","wrap_content":"index_1JMx6Qh","wrap_content_str":"index_3OD85Eh","s1":"index_3Isf1kX"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/authorBenefit/index.css
// module id = 1061
// module chunks = 0